import React from 'react';

import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './StatusPills.module.scss';

export const StatusPill = ({
  text,
  status,
  className,
  tooltip,
  colorDot,
  icon,
  iconSize = '16',
  iconColor = 'text-neutral-7',
  prefix,
  large = false,
  small = false,
  capitalize = false,
  onClick = () => {},
}) => {
  const getStatusClass = () => {
    const statusMap = {
      error: styles.error,
      continue: styles.continue,
      neutral: styles.neutral,
      light: styles.light,
      success: styles.success,
      warning: styles.warning,
      completed: styles.success,
      pending: styles.warning,
      canceled: styles.neutral,
      overdue: styles.error,
      candidate: styles.warningLight,
    };

    const statusKey = status != null ? String(status).toLowerCase() : '';
    return cn(styles.root, statusMap[statusKey] || styles.continue, {
      [className]: className,
      [styles.prefixLayout]: prefix,
      [styles.large]: large,
      [styles.small]: small,
    });
  };

  return (
    <>
      {text && (
        <OverlayTrigger
          trigger={tooltip ? ['hover', 'focus'] : 'none'}
          placement="top"
          overlay={<Tooltip>{tooltip}</Tooltip>}>
          <div className={cn(getStatusClass(), { 'u-capitalize': capitalize })} onClick={onClick}>
            {colorDot && (
              <span className={cn('inline-block w-3 h-3 rounded-full mr-2', colorDot)} />
            )}
            {prefix && (
              <span className={cn(styles.prefix, 'secondary-text u-font-weight-600')}>
                {prefix}
              </span>
            )}
            {icon && (
              <HugeiconsIcon icon={icon} size={iconSize} className={cn('mr-2', iconColor)} />
            )}
            {text}
          </div>
        </OverlayTrigger>
      )}
    </>
  );
};

export default StatusPill;
